// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedRecord: null
}

const record = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_RECORD_ACCOUNT_SETTINGS':
      return { ...state, selectedRecord: action.selectedRecord }
    case 'EDIT_RECORD_ACCOUNT_SETTINGS':
      return { ...state }  
    default:
      return { ...state }
  }
}
export default record
